import Main from './Main'

export default function TelaInicio(){
    return (
        <>
            <Main/>
        </>
    )
}